import { render, staticRenderFns } from "./te-tabbar.vue?vue&type=template&id=089dd615"
import script from "./te-tabbar.vue?vue&type=script&lang=js"
export * from "./te-tabbar.vue?vue&type=script&lang=js"
import style0 from "./te-tabbar.vue?vue&type=style&index=0&id=089dd615&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports